"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTION = void 0;
/** Actions possible */
var ACTION;
(function (ACTION) {
    ACTION["CREATE"] = "create";
})(ACTION || (exports.ACTION = ACTION = {}));
//# sourceMappingURL=content-data-types.js.map